import { GenericLandingCard, GenericLandingCardHeader } from "../components";
import { GenericBackToBtn } from "components/buttons";
import {
  buttonBackToLogin,
  notLogged404SubTitle,
  notLogged404Title,
} from "../_constants";

export const NotLogged404Page = () => {
  return (
    <GenericLandingCard
      rightColumn={
        <GenericLandingCardHeader
          title={notLogged404Title}
          subtitle={notLogged404SubTitle}
          gap={16}
        ></GenericLandingCardHeader>
      }
      leftInteraction={<GenericBackToBtn label={buttonBackToLogin} link="/" />}
    ></GenericLandingCard>
  );
};
